// removed by extract-text-webpack-plugin
module.exports = {"list":"_3cTkxj2In _1shSFM5K_","option":"_1FIo9mV9K _19D5W2N5e","radio":"_2Klm12Ui4 _2qV3kzJTO"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/event-type-selector/event-type-selector-list/event-type-selector-list.css
 ** module id = 2160
 ** module chunks = 0
 **/